import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../logo.svg';

class Inicio extends React.Component {
    render() {
        return(
            <div>
                <img src={logo} className="App-logo" alt="logo" />
                <br/>
                <Link to={`/video/57`}>
                 Video 57
                </Link>
                <Link to={`/video/58`}>
                 Video 58
                </Link>
            </div>
        );
    }
}

export default Inicio;